import React from 'react';
import { ShoppingBag, Star, Truck } from 'lucide-react';

const styles = {
  hero: {
    background: 'linear-gradient(135deg, var(--green-dark) 0%, var(--green-mid) 60%, #3d8b4e 100%)',
    color: 'white',
    padding: '60px 20px',
    position: 'relative',
    overflow: 'hidden',
  },
  inner: {
    maxWidth: '1200px',
    margin: '0 auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '40px',
    position: 'relative',
    zIndex: 1,
  },
  left: {
    flex: 1,
    animation: 'fadeInUp 0.6s ease both',
  },
  eyebrow: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    background: 'rgba(255,255,255,0.15)',
    backdropFilter: 'blur(8px)',
    border: '1px solid rgba(255,255,255,0.25)',
    borderRadius: '50px',
    padding: '6px 16px',
    fontSize: '13px',
    fontWeight: 700,
    marginBottom: '20px',
    color: 'var(--orange-light)',
  },
  h1: {
    fontFamily: 'var(--font-display)',
    fontSize: 'clamp(2rem, 5vw, 3.2rem)',
    fontWeight: 800,
    lineHeight: 1.15,
    marginBottom: '16px',
  },
  h1Accent: {
    color: 'var(--orange-light)',
  },
  sub: {
    fontSize: '16px',
    opacity: 0.88,
    lineHeight: 1.6,
    marginBottom: '32px',
    maxWidth: '480px',
  },
  btnGroup: {
    display: 'flex',
    gap: '14px',
    flexWrap: 'wrap',
  },
  btnPrimary: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    background: 'var(--orange)',
    color: 'white',
    border: 'none',
    padding: '14px 28px',
    borderRadius: '50px',
    fontFamily: 'var(--font-main)',
    fontWeight: 800,
    fontSize: '15px',
    cursor: 'pointer',
    boxShadow: '0 4px 16px rgba(232,134,10,0.4)',
    transition: 'transform 0.2s, box-shadow 0.2s',
  },
  btnSecondary: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    background: 'rgba(255,255,255,0.15)',
    color: 'white',
    border: '2px solid rgba(255,255,255,0.4)',
    padding: '14px 28px',
    borderRadius: '50px',
    fontFamily: 'var(--font-main)',
    fontWeight: 700,
    fontSize: '15px',
    cursor: 'pointer',
    transition: 'background 0.2s',
  },
  badges: {
    display: 'flex',
    gap: '20px',
    marginTop: '36px',
    flexWrap: 'wrap',
  },
  badge: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '13px',
    fontWeight: 700,
    opacity: 0.9,
  },
  right: {
    flex: '0 0 auto',
    width: '340px',
    animation: 'fadeIn 0.8s ease 0.3s both',
  },
  bannerImg: {
    width: '100%',
    borderRadius: '20px',
    boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
    border: '3px solid rgba(255,255,255,0.2)',
    objectFit: 'cover',
  },
  decorCircle1: {
    position: 'absolute',
    top: '-80px',
    right: '-80px',
    width: '300px',
    height: '300px',
    borderRadius: '50%',
    background: 'rgba(255,255,255,0.05)',
    zIndex: 0,
  },
  decorCircle2: {
    position: 'absolute',
    bottom: '-60px',
    left: '30%',
    width: '200px',
    height: '200px',
    borderRadius: '50%',
    background: 'rgba(255,255,255,0.04)',
    zIndex: 0,
  },
};

export default function Hero() {
  return (
    <section style={styles.hero}>
      <div style={styles.decorCircle1} />
      <div style={styles.decorCircle2} />

      <div style={styles.inner}>
        <div style={styles.left}>
          <div style={styles.eyebrow}>
            <Star size={14} fill="currentColor" />
            ¡Bienvenido a ShuCore.online!
          </div>

          <h1 style={styles.h1}>
            Productos que{' '}
            <span style={styles.h1Accent}>mejoran</span>
            <br />tu hogar y tu vida
          </h1>

          <p style={styles.sub}>
            Encuentra todo lo que necesitas para mascotas, hogar, limpieza y tecnología.
            Calidad garantizada con los mejores precios de Chile.
          </p>

          <div style={styles.btnGroup}>
            <button
              style={styles.btnPrimary}
              onMouseEnter={e => {
                e.currentTarget.style.transform = 'scale(1.05)';
                e.currentTarget.style.boxShadow = '0 6px 24px rgba(232,134,10,0.5)';
              }}
              onMouseLeave={e => {
                e.currentTarget.style.transform = 'scale(1)';
                e.currentTarget.style.boxShadow = '0 4px 16px rgba(232,134,10,0.4)';
              }}
              onClick={() => document.getElementById('productos')?.scrollIntoView({ behavior: 'smooth' })}
            >
              <ShoppingBag size={18} />
              Ver productos
            </button>
            <button
              style={styles.btnSecondary}
              onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,255,255,0.25)'}
              onMouseLeave={e => e.currentTarget.style.background = 'rgba(255,255,255,0.15)'}
            >
              Ver recomendaciones 🏷️
            </button>
          </div>

          <div style={styles.badges}>
            <div style={styles.badge}>
              <Truck size={16} color="var(--orange-light)" />
              Envío a todo Chile
            </div>
            <div style={styles.badge}>
              <span>🔒</span>
              Pago seguro
            </div>
            <div style={styles.badge}>
              <span>⭐</span>
              +4.8 valoración
            </div>
          </div>
        </div>


      </div>
    </section>
  );
}
